import { createDerived, createStore, update } from '@kundinos/nanostores';

import * as PageProductStore from '@Stores/PageProduct';
import { isBrowser } from '@Utils/checkRuntime';

import type { PageProductData, Parameter, ViewerModelData } from '@Pages/PageProduct';
import type { ModuleProductData } from '@Types/ModuleProduct';
import type { ParameterValueData } from '@Types/Cart';

export interface AllVariantsData {
  [key: number]: boolean;
}

export interface DataStoreValue extends PageProductData {
  parameterValues?: ParameterValueData[];
  blocked?: boolean;
}

export const dataStore = createStore<DataStoreValue>();

// Начальные параметры (не изменяются после инициализации)
export const initialParametersStore = createStore<Parameter[]>(() => {
  update(initialParametersStore, (prev) => prev || []);
});

// Текущие параметры
export const currentParametersStore = createStore<Parameter[]>(() => {
  update(currentParametersStore, (prev) => prev || []);
});

// Изменяемые параметры без учета параметра размера и спального места
export const changeableParametersStore = createDerived(
  [currentParametersStore],
  (currentParameters) => {
    return currentParameters.filter((parameter) => {
      return parameter.theme === 'dropdown' && parameter.view === 'modal';
    });
  },
);

// Добавляются Размеры и Спальные места с возможностью выбора из вариантов
export const sizeParameterStore = createDerived([currentParametersStore], (currentParameters) => {
  return currentParameters.find((parameter) => {
    return parameter.view === 'select' && parameter.variants?.length > 1;
  });
});

export const modulesStore = createStore<ModuleProductData[]>();

export const viewerModelStore = createStore<ViewerModelData[]>(() => {
  viewerModelStore.set([]);
});

// Обновляем информацию на странице при изменении модулей или параметров
function handleUpdate() {
  if (!isBrowser) return;
  if (dataStore.value?.blocked) return;

  PageProductStore.updateData();
}

modulesStore.listen(handleUpdate);
changeableParametersStore.listen(handleUpdate);
